<template>
  <div class="mission-page">
    <mission-list-pane class="mission-page__list" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MissionListPane from '@/components/MissionPage/MissionListPane.vue'

export default defineComponent({
  name: 'MissionPage',
  components: {
    MissionListPane,
  },
})
</script>

<style scoped lang="scss">
.mission-page {
  background: $black20;
  height: 100%;
}
</style>
